import { useState, useEffect } from 'react';
export function useListEditor(_ref) {
  let {
    data,
    updateFn,
    showCreateComponent,
    onCreateDismiss
  } = _ref;
  const [deleteIndex, setDeleteIndex] = useState(-1);
  const [addIsVisible, setAddIsVisible] = useState(showCreateComponent);
  const [editIndex, setEditIndex] = useState(-1);
  useEffect(() => {
    if (showCreateComponent) {
      setEditIndex(-1);
      setDeleteIndex(-1);
      setAddIsVisible(true);
    } else {
      setAddIsVisible(false);
    }
  }, [showCreateComponent]);

  // DELETE -----------------------

  function onDeleteSelect(itemIndex) {
    const item = data && data[itemIndex];
    if (!item) return;
    setEditIndex(-1);
    setAddIsVisible(false);
    setDeleteIndex(itemIndex);
  }
  function onDeleteAction() {
    if (deleteIndex === undefined) return;
    //make sure new copy is returned (immutabiilty) // will prob use immer for this.
    const updated = [...data];
    if (!updated) return;
    updated.splice(deleteIndex, 1);
    setDeleteIndex(-1);
    updateFn(updated);
  }
  function onDeleteDismiss() {
    setDeleteIndex(-1);
  }

  // EDIT -----------------------

  function onEditSelect(itemIndex) {
    const itemToEdit = data && data[itemIndex];
    if (itemToEdit === undefined) return;
    setDeleteIndex(-1);
    setAddIsVisible(false);
    setEditIndex(itemIndex);
  }
  function onItemUpdated(updatedData) {
    if (editIndex < 0 && data) return;
    const updated = [...data];
    updated[editIndex] = updatedData;
    updateFn(updated);
  }
  function onEditDismiss() {
    setEditIndex(-1);
  }

  // CREATE -----------------------

  function onAddSelect() {
    setEditIndex(-1);
    setDeleteIndex(-1);
    setAddIsVisible(true);
  }
  function onItemCreated(newData) {
    const updatedItemList = [...data, newData];
    updateFn(updatedItemList);
    setAddIsVisible(false);
    onCreateDismiss && onCreateDismiss();
  }
  function onAddDismiss() {
    setEditIndex(-1);
    setAddIsVisible(false);
    onCreateDismiss && onCreateDismiss();
  }
  return {
    onDeleteSelect: onDeleteSelect,
    onDeleteAction: onDeleteAction,
    onDeleteDismiss: onDeleteDismiss,
    deleteIndex: deleteIndex,
    onEditSelect: onEditSelect,
    onItemUpdated: onItemUpdated,
    editIndex: editIndex,
    onEditDismiss: onEditDismiss,
    onItemCreated: onItemCreated,
    onAddSelect: onAddSelect,
    onAddDismiss: onAddDismiss,
    addIsVisible: addIsVisible
  };
}